import View from './view';
import {Props} from './model';

export const ContactsCard = (props: Props) => {
  return View(props);
};
